import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './DataStats.css';

// Import the three images
import statsGraph from '../../assets/images/stats-graph.png';
import statsMap from '../../assets/images/stats-graph1.png';
import statsApi from '../../assets/images/stats-api.png';

const carouselImages = [statsGraph, statsMap, statsApi];

const DataStats = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setActiveIndex((prevIndex) =>
          prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
        ),
      4000
    );
    return () => {
      resetTimeout();
    };
  }, [activeIndex]);

  return (
    <section className="stats-section">
      {/* This new wrapper will contain and align everything */}
      <div className="stats-wrapper">
        <div className="section-header">
          <h2>Data & Statistics</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          Access trade data with historical price records for critical business decisions.
        </p>

        <div className="stats-content-container">
          <div className="stats-carousel-col">
            <div className="stats-slides-wrapper" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
              {carouselImages.map((image, index) => (
                <div className="stats-slide" key={index}>
                  <img src={image} alt={`Data visualization ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          <div className="stats-features-col">
            <div className="feature-item">
              <h3>Wide data coverage</h3>
              <p>Get information on historical prices, production, trade, and inventory across various crops.</p>
            </div>
            <div className="feature-item">
              <h3>Real time trade tracking</h3>
              <p>Track shipments, monitor port activity, and analyse trade routes with origin, destination and customs-level precision.</p>
            </div>
            <div className="feature-item">
              <h3>Simple integration</h3>
              <p>Use APIs or Excel plugins to feed data straight into your existing workflows.</p>
            </div>
          </div>
        </div>

        <div className="explore-more-container">
          <Link to="/data-statistics">
            <button className="explore-more-btn">Explore more</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DataStats;